<script setup lang="ts">
import type { NumericValueDto } from '@/api/generator';
import NumericValueField from '@/components/forms/dataTypes/NumericValueField.vue';
import { VeeNumericValueFieldProps } from '@/components/forms/types.ts';
import { useField, useFieldError } from 'vee-validate';
import { toRef } from 'vue';
import { useVeeFormProps } from '../utils';

const props = defineProps<VeeNumericValueFieldProps>();

const emits = defineEmits<{
  'update:modelValue': [value: NumericValueDto | undefined];
}>();

const veeProps = useVeeFormProps(props);

const { value, handleChange, meta, errorMessage } = useField<NumericValueDto | undefined>(
  toRef(() => props.name),
  undefined,
  {
    validateOnValueUpdate: false,
  },
);

const valueError = useFieldError(toRef(() => `${props.name}.value`));

function onUpdate(input: NumericValueDto | undefined) {
  handleChange(input, meta.touched);
  emits('update:modelValue', input);
}
</script>

<template>
  <NumericValueField
    class="vee-numeric-value-field"
    v-bind="veeProps"
    :modelValue="value"
    :errorMessage="valueError || errorMessage"
    @update:modelValue="onUpdate"
  />
</template>
